import { IconContext } from "react-icons";

const settings = { className: "text-primary", size: "1.7em" };

type Props = {
  children: React.ReactNode;
};

export const IconProvider = (props: Props) => <IconContext.Provider value={settings}>{props.children}</IconContext.Provider>;
